<mat-card>
    <mat-form-field>
        <input matInput [(ngModel)]="newItem" placeholder="Enter item" required="true">
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="addItem()">Add</button>
    <button mat-raised-button color="accent" (click)="clearItems()">Clear</button>
</mat-card>